<template lang="pug">
.case-container
  .case-content
    .case-case__title
        .divider
        .title__content
          span {{ $t('案例分享：梅特勒-托利多') }}
          span {{ $t('面向全球的天平衡器和精密仪器制造商。') }}
    .case-case__summary
      div
        i.iconfont.iconhangye
        span {{ $t('广告主行业：精密仪器及衡器') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('为梅特勒提供搜索引擎账户的数据整合和优化服务。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content 1）{{ $t('在多个渠道投放了广告，但查看数据时需要浪费大量的时间来汇总整合数据。') }}
        .content 2）部分高消费关键词实际到达官网较少，转化数表现普通。
        .content 3）给关键词设置了很高的出价也没有达到满意的排名，造成了不必要的浪费。
        .content 4）虚假IP的点击量越来越多，但很难通过人工进行排查。
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content 1）跨搜索引擎整合数据：整合各搜索引擎数据，可以同时查看和下载跨搜索引擎的汇总、分搜索引擎、不同搜索引擎内各个层级的数据。
        .content 2）投放数据分析：对投放数据效果进行分析，并提出对应的优化建议。
        .content 3）关键词网站数据监测：在网站安装复歌的监测代码后，通过对每个关键词单独生成追踪代码，然后将追踪代码上传至搜索引擎后台，来监测各个关键词的网站数据和转化数据。
        .content 4）关键词锁定排名：根据设置的目标排名和出价范围，系统每小时会监测关键词的排名并进行调价。在保证排名的同时优化出价，从而实现以最优的价格取得目标排名的效果。
        .content 5）反作弊：通过与专为客户过滤和分析虚假IP的数据提供商RTB Asia连通IP数据库，只要在网站安装复歌的代码，就能够识别99.98%的到访IP，实时将虚假IP加入搜索引擎黑名单。
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content 1）{{ $t('客户可以更加便捷的查看和下载各搜索引擎的数据和汇总后的数据，并且可以知道自己广告投放的效果怎么样，以及下一步的优化方案。') }}
        .content 2）{{ $t('使用锁定排名功能的201个关键词，有87%达到了目标排名，对比使用前CPC下降29%。使用反作弊功能后屏蔽了大量的可疑IP，占总IP量的16%。') }}
  MobileContact
</template>"
<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    MobileContact
  }
}
</script>
